<template lang="pug">
Teleport(to="body")
  Transition(name="web-app-success-banner")
    .web-app-success-banner(
      v-if="successBannerVisible && !isEmbedded"
      role="status"
      aria-live="polite"
    )
      svg.web-app-success-banner__icon(
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden="true"
      )
        path(
          fill="currentColor"
          d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
        )
      span {{ successBannerMessage }}
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { isEmbeddedContext, isEmbeddedRoute } from '@/utils/embeddedUtils';
import {
  successBannerMessage,
  successBannerVisible,
} from '@/composables/useWebAppSuccessBanner';

export default defineComponent({
  name: 'WebAppSuccessBanner',
  setup() {
    const route = useRoute();

    const isEmbedded = computed(() => (
      isEmbeddedRoute(route.path)
      || isEmbeddedContext()
      || route.query.embedded === 'true'
      || !!route.query.embedOrganizationId
    ));

    return {
      successBannerMessage,
      successBannerVisible,
      isEmbedded,
    };
  },
});
</script>

<style lang="scss">
.web-app-success-banner {
  position: fixed;
  top: calc(64px + env(safe-area-inset-top, 0px));
  left: 16px;
  right: 16px;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(90deg, #0d9488 0%, #14b8a6 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 9999px;
  box-shadow: 0 8px 24px rgba(13, 148, 136, 0.35);
  pointer-events: none;

  @media (min-width: 768px) {
    top: 16px;
    left: 0;
    right: 0;
    width: fit-content;
    max-width: calc(100vw - 32px);
    margin: 0 auto;
  }
}

.web-app-success-banner__icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.web-app-success-banner-enter-active {
  animation: web-app-success-banner-in 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.web-app-success-banner-leave-active {
  animation: web-app-success-banner-out 0.25s ease-in forwards;
}

@keyframes web-app-success-banner-in {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes web-app-success-banner-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(-12px);
  }
}
</style>
